import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import Pagination from '@material-ui/lab/Pagination';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Table } from '../../components/Table';
import { StyledLink } from '../../components/Buttons';
import PanelContentWrapper from '../../components/PanelContentWrapper';
import { apiUrl } from '../../api';
import { Button, SearchInput } from '../../components/FormComponents';
import { Modal, ModalButtons } from '../../components/Modal';
import useDebounce from '../../hooks/debounce';
import { Permission } from '../../hooks/Permission';

const StyledTopWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    input {
        margin-right: 15px;
    }
`;

export const AdminList = () => {
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const token = useSelector((store) => store.token);
    const [users, setUsers] = useState([]);
    const [modalId, setModalId] = useState(null);
    const [change, setChange] = useState(0);
    const permissions = useSelector(({ permissions: p }) => p);

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 1000, setPage);
    useEffect(() => {
        axios
            .get(`${apiUrl}/user`, {
                params: {
                    page,
                    search: debouncedSearchTerm,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(({ data: { users: newUsers, lastPage } }) => {
                setUsers(newUsers);
                setPages(lastPage);
            });
    }, [token, page, change, debouncedSearchTerm]);
    return (
        <>
            <Permission permission="admin-index" />
            <PanelContentWrapper>
                <StyledTopWrapper>
                    <SearchInput onChange={(e) => setSearchTerm(e.target.value)} />
                    <StyledLink to="/administratorzy/dodaj">Dodaj Admina</StyledLink>
                </StyledTopWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th>Nazwa</th>
                            <th>E-mail</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(({ id, name, email }) => (
                            <tr key={id}>
                                <td>{name}</td>
                                <td>{email}</td>
                                <td>
                                    {permissions.includes('admin-destroy') && (
                                        <FontAwesomeIcon
                                            onClick={() => {
                                                setModalId(id);
                                            }}
                                            icon={faTrash}
                                            fixedWidth
                                        />
                                    )}
                                    <Link to={`/administratorzy/${id}`}>
                                        <FontAwesomeIcon icon={faArrowRight} fixedWidth />
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Pagination
                    count={pages}
                    page={page}
                    size="large"
                    shape="rounded"
                    onChange={(event, pageNumber) => {
                        setPage(pageNumber);
                    }}
                />
            </PanelContentWrapper>
            {modalId && (
                <Modal
                    closeModal={() => {
                        setModalId(null);
                    }}
                >
                    <p>Czy na pewno usunąć administratora?</p>
                    <ModalButtons>
                        <Button
                            onClick={() => {
                                axios
                                    .delete(`${apiUrl}/user/${modalId}`, {
                                        headers: {
                                            Authorization: `Bearer ${token}`,
                                        },
                                    })
                                    .then(() => {
                                        setChange(change + 1);
                                        setModalId(null);
                                    });
                            }}
                        >
                            Tak
                        </Button>
                        <Button
                            secondary
                            onClick={() => {
                                setModalId(null);
                            }}
                        >
                            Nie
                        </Button>
                    </ModalButtons>
                </Modal>
            )}
        </>
    );
};
